import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './filter-item.css';

class FilterItem extends Component {
  onClick = () => {
    this.props.onClick({
      id: this.props.id,
      text: this.props.text
    });
  }

  render() {
    let className = 'filter-item';
    className += this.props.isSelected ? ' selected' : '';

    return (
      <button 
        onClick={this.onClick} 
        className={className}
        aria-label={this.props.text}>

          {this.props.text}
      </button>
    );
  }
}

FilterItem.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default FilterItem;